module.exports = __webpack_public_path__ + "static/media/dotsIcon.fee95343.svg";